module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/instagram/chapel_sns_03-da920d1eb433f4de2a1cf7f52bea1194.jpg";